import React from 'react';
import { useKeyboardNavigation } from '../../hooks/useKeyboardNavigation';

interface SkipLinkProps {
  targetId: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const SkipLink: React.FC<SkipLinkProps> = ({
  targetId,
  children = 'Skip to main content',
  className = '',
  onClick
}) => {
  const { handleKeyDown } = useKeyboardNavigation({
    onEnter: () => {
      const target = document.getElementById(targetId);
      if (target) {
        target.focus();
        target.scrollIntoView({ behavior: 'smooth' });
        onClick?.();
      }
    },
    onSpace: () => {
      const target = document.getElementById(targetId);
      if (target) {
        target.focus();
        target.scrollIntoView({ behavior: 'smooth' });
        onClick?.();
      }
    }
  });

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
      onClick?.();
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      onKeyDown={(e) => handleKeyDown(e.nativeEvent)}
      className={`skip-link ${className}`}
      aria-label={typeof children === 'string' ? children : 'Skip to main content'}
    >
      {children}
    </a>
  );
};

export default SkipLink;
